

class DashboardChart {
  constructor(root, data, options = {}) {
    this.root = root
    this.color = options.color || '#888'
    this.margin = { top: 20, right: 0, bottom: 24, left: 48 }
    this.width = options.width - this.margin.left - this.margin.right
    this.height = options.height - this.margin.top - this.margin.bottom
    this.yAxisPrefix = options.yAxisPrefix || ''
    this.tooltipText = options.tooltipText || ''

    this.initData(data)
  }

  initData(data) {
    this.data = data

    this.x = d3
      .scaleTime()
      .domain([data[0].date, data[data.length - 1].date])
      .rangeRound([12, this.width - 12])

    this.y = d3
      .scaleLinear()
      .domain([0, d3.max(data, d => d.value) * 1.2])
      .range([this.height, 0])

    this.xAxis = d3.axisBottom(this.x).ticks(6)

    this.yAxis = d3
      .axisLeft(this.y)
      .ticks(4)
      .tickSize(this.width)
      .tickFormat(v => this.yAxisPrefix + d3.format('~s')(v))
  }

  formatTooltip(value) {
    const formatNumber = d3.format(',')
    const n = formatNumber(value)

    return `${n} ${this.tooltipText}`
  }

  handleMouseOver(event, d, i) {
    const x = this.x

    d3.select(this.root)
      .select('.dashboard-chart__tooltip')
      .style('left', x(d.date) + 'px')
      .style('opacity', 1)

    d3.select(this.root)
      .select('.dashboard-chart__tooltip-label')
      .text(d3.timeFormat('%_d %B %Y')(d.date))

    d3.select(this.root)
      .select('.dashboard-chart__tooltip-text')
      .attr('class', 'dashboard-chart__tooltip-text')
      .text(this.formatTooltip(d.value))

    d3.select(this.root)
      .selectAll('.dashboard-chart__line-dot')
      .attr('fill-opacity', (d, index) => (index === i ? 0.3 : 0))
  }

  handleMouseOut(event, d, i) {
    d3.select(this.root)
      .selectAll('.dashboard-chart__tooltip')
      .data([d])
      .style('opacity', 0)

    d3.select(this.root)
      .selectAll('.dashboard-chart__line-dot')
      .attr('fill-opacity', 0)
  }

  customYAxis(g) {
    g.call(this.yAxis)
    g.select('.domain').remove()
    g.selectAll('.tick:not(:first-of-type) line').attr('stroke-dasharray', '6,6')
    g.selectAll('.tick text').attr('x', -(this.width + 12))
  }

  customXAxis(g) {
    g.call(this.xAxis)
    g.select('.domain').remove()
    g.selectAll('.tick text').attr('y', 12)
  }

  render() {
    const { width, height, margin, data, x, y, color } = this

    // Svg
    const svg = d3
      .select(this.root)
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)

    // Axes
    svg
      .append('g')
      .attr('class', 'dashboard-chart__x-axis')
      .attr('transform', `translate(${margin.left},${height + margin.top})`)
      .call(this.customXAxis.bind(this))

    svg
      .append('g')
      .attr('class', 'dashboard-chart__y-axis')
      .attr('transform', `translate(${width + margin.left}, ${margin.top})`)
      .call(this.customYAxis.bind(this))

    // Canvas
    const canvas = svg.append('g').attr('transform', `translate(${margin.left},${margin.top})`)

    // Path
    const line = d3
      .line()
      .x(d => x(d.date))
      .y(d => y(d.value))

    canvas
      .append('path')
      .datum(data)
      .attr('class', 'dashboard-chart__line')
      .attr('d', line)
      .style('stroke', color)

    // Dots
    canvas
      .selectAll('.dashboard-chart__line-dot')
      .data(data)
      .enter()
      .append('circle')
      .attr('class', 'dashboard-chart__line-dot')
      .attr('cx', d => x(d.date))
      .attr('cy', d => y(d.value))
      .attr('fill-opacity', 0)
      .attr('fill', color)
      .attr('r', 7)

    // Tooltip
    const container = d3
      .select(this.root)
      .append('div')
      .style('position', 'absolute')
      .style('top', margin.top + 'px')
      .style('bottom', margin.bottom + 'px')
      .style('left', margin.left + 'px')
      .style('right', margin.right + 'px')

    container
      .selectAll('dashboard-chart__div')
      .data(data)
      .enter()
      .append('div')
      .attr('class', 'dashboard-chart__div')
      .style('position', 'absolute')
      .style('top', '0px')
      .style('left', d => x(d.date) + 'px')
      .style('margin-left', -width / data.length / 2 + 'px')
      .style('width', Math.round(width / data.length + 1) + 'px')
      .style('height', height + 'px')
      .on('mouseover', this.handleMouseOver.bind(this))
      .on('mouseout', this.handleMouseOut.bind(this))

    const tooltip = container
      .selectAll('.dashboard-chart__tooltip')
      .data([data[0]])
      .enter()
      .append('div')
      .attr('class', 'dashboard-chart__tooltip')
      .style('position', 'absolute')
      .style('top', '0px')
      .style('left', d => x(d.date) + 'px')
      .style('height', height + 'px')

    const flag = tooltip.append('div').attr('class', 'dashboard-chart__tooltip-flag')

    flag
      .append('div')
      .attr('class', 'dashboard-chart__tooltip-label')
      .text('Date')

    flag
      .append('div')
      .attr('class', 'dashboard-chart__tooltip-text')
      .text('Text')
  }

  update(data) {
    this.root.innerHTML = ''
    this.initData(data)
    this.render()
  }
}

window.DashboardChart = DashboardChart
